export function toPercentageOfTotal(partialValue: number, totalValue: number): number {
  if (totalValue === 0) return 0
  return Number(((partialValue / totalValue) * 100).toFixed(2))
}
